import { User } from './User';

export enum QuestionType {
  INPUT = 'INPUT',
  NUMBER = 'NUMBER',
  VALUE = 'VALUE',
  BOOLEAN = 'BOOLEAN',
  TEXTAREA = 'TEXTAREA',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  DATE = 'DATE',
  ADDRESS = 'ADDRESS',
  COUNTRIES = 'COUNTRIES',
  STATES = 'STATES',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  SSN = 'SSN',
  SSN_EIN = 'SSN_EIN',
}

export interface Task {
  id: string;
  name: string;
  order: number;
  steps?: TaskStep[];
}

export interface TaskStep {
  id: string;
  name: string;
  order: number;
  questions?: Question[];
  questionsGroups?: QuestionsGroup[];
  task?: Task;
}

export interface QuestionsGroup {
  id: string;
  name: string | null;
  duplicable: boolean;
  questions?: Question[];
  step?: TaskStep;
  stepId: string;
  user?: User;
  referencedGroup?: QuestionsGroup;
  referencedGroupId: string | null;
}

export interface Question {
  id: string;
  title: string;
  placeholder: string | null;
  type: QuestionType;
  order: number;
  referenced_table: string | null;
  referenced_column: string | null;
  values?: string[];
  answers?: Answer[];
  step?: TaskStep;
  stepId: string;
  group?: QuestionsGroup;
}

export interface Answer {
  id: string;
  answer: string | string[];
  question?: Question;
  user?: User;
}
